import { Typography } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";
import STRINGS from "../constants/constants";

export default function NothingToShow() {
  return (
    <div className="flex h-full w-full items-center">
      <Typography className="text-[14px]" color={HNSColors.neutrals[500]}>
        {STRINGS.NOTHING_TO_SHOW}
      </Typography>
    </div>
  );
}
